import React from 'react';

// Top-level error boundary. If any page/component throws during render, show a
// recoverable fallback (reload / go home) instead of white-screening the whole
// app. Added after a render-time crash blanked the expense page in production —
// this keeps one bad page from taking down the entire tool.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface to the console for diagnostics; there's no server-side error
    // sink wired up, so this is the record of what crashed.
    console.error('[ErrorBoundary] Uncaught render error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-6">
        <div className="max-w-md w-full rounded-xl border border-border bg-card p-6 text-center shadow-lg">
          <h1 className="text-lg font-semibold text-foreground">Something went wrong</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            This page hit an unexpected error. Your saved data is safe. Try reloading —
            if it keeps happening, let the ProHR admin know.
          </p>
          {this.state.error?.message && (
            <p className="mt-3 rounded-md bg-muted/50 px-3 py-2 text-left font-mono text-xs text-muted-foreground break-words">
              {this.state.error.message}
            </p>
          )}
          <div className="mt-5 flex justify-center gap-3">
            <button
              onClick={() => window.location.reload()}
              className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              Reload
            </button>
            <button
              onClick={() => window.location.assign('/')}
              className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground hover:bg-accent transition-colors"
            >
              Go to home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
